import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Heading,
  ModalFooter,
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { finleyAssert } from '@finley-technologies/common';

import { LpToCfEntityGrouping } from '../types';
import { Select } from 'packages/common-frontend/components/Select';
import { Icon } from '~/packages/common-frontend/components/icons';

type CreateAssignmentStrategyButtonProps = {
  loanProductCreditFacilityGroupings: LpToCfEntityGrouping[];
};
export const CreateAssignmentStrategyButton = ({
  loanProductCreditFacilityGroupings,
}: CreateAssignmentStrategyButtonProps) => {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [
    selectedImplementationId,
    setSelectedImplementationId,
  ] = useState<string>();

  useEffect(() => {
    finleyAssert(
      loanProductCreditFacilityGroupings.length > 0,
      `Expected an implementation to exist`,
    );
    setSelectedImplementationId(
      loanProductCreditFacilityGroupings[0].implementationId,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Button
        aria-label="create new strategy"
        leftIcon={<Icon icon="plus" />}
        variant="secondary"
        colorScheme="v2-aurora"
        onClick={() => {
          if (loanProductCreditFacilityGroupings.length === 1) {
            navigate(
              `/settings/assignment-strategy/new/${selectedImplementationId}`,
            );
          }
          setIsOpen(true);
        }}
      >
        Create New Strategy
      </Button>

      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <ModalOverlay />
        <ModalContent padding="20px">
          <ModalHeader fontWeight="bold">Create New Strategy</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Heading size="sm" fontWeight="semibold" mb="8px">
              Select Group
            </Heading>
            <Select
              value={selectedImplementationId}
              options={loanProductCreditFacilityGroupings.map(
                ({ implementationId, loanProducts }) => ({
                  value: implementationId,
                  label: loanProducts
                    .map((loanProduct) => loanProduct.name)
                    .join(', '),
                }),
              )}
              onChange={(implementationId?: string) => {
                if (implementationId) {
                  setSelectedImplementationId(implementationId);
                }
              }}
              isDisabled={false}
            />
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="aurora"
              onClick={async () => {
                navigate(
                  `/settings/assignment-strategy/new/${selectedImplementationId}`,
                );
              }}
              ml={3}
            >
              Create strategy
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
